import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './Container/App'
import 'bootstrap/dist/css/bootstrap.css';
import '../src/style.css';
import {Provider} from 'react-redux'
import rootReducer from './Redux/Reducers'
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

const store = createStore(

  rootReducer,
  applyMiddleware(thunk), 
);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
